<template>
    <div :style="{'border-color': color}" class="pd-widget">
        <div class="widget-headline flex" :style="[{'border-color': color}, isOpen ? '' : 'border-bottom: none']">
            <router-link v-if="widget.defaultRoute && clickable" #default="{navigate}" :to="widget.defaultRoute" class="overflow-hidden">
                <div class="headline-name text-overflow" :style="{color: color}">
                    <i class="material-icons" aria-hidden="true" role="img">{{widget.icon}}</i>
                    <span>{{title}}</span>
                </div>
            </router-link>
            <div v-else class="headline-name text-overflow" :style="{color: color}">
                <i class="material-icons" aria-hidden="true" role="img">{{widget.icon}}</i>
                <span class="overflow-hidden">{{title}}</span>
            </div>
            <div v-interact="() => toggleOpen()" class="widget-right-icon no-select pointer" :style="{color: color}"
                :title="isOpen ? 'Zuklappen' : 'Aufklappen'">
                <i class="material-icons" aria-hidden="true" role="img">
                    {{isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                </i>
            </div>
        </div>
        <div :class="{'pd-container-closed': !isOpen, 'widget-inner-placeholder-small': content.entries && !content.entries.length}">
            <slot>
                <component :is="'widget-' + widget.template" :widget="widget" :content="content"/>
            </slot>
        </div>
    </div>
</template>

<script lang="ts">
    import WidgetFAQ from './WidgetFAQ.vue';
    import WidgetOpenFeedback from './WidgetOpenFeedback.vue';
    import WidgetOpenRequests from './WidgetOpenRequests.vue';
    import WidgetTicket from './WidgetTicket.vue';
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import {State} from 'vuex-facing-decorator';
    import ActionMenu from '../ActionMenu.vue';
    import WidgetCalendar from './WidgetCalendar.vue';
    import WidgetDefault from './WidgetDefault.vue';
    import WidgetResubmission from './WidgetResubmission.vue';
    import WidgetStorage from './WidgetStorage.vue';
    import WidgetTask from './WidgetTask.vue';
    import WidgetBirthday from './WidgetBirthday.vue';
    import WidgetTasktraced from './WidgetTasktraced.vue';
    import WidgetEvent from './WidgetEvent.vue';
    import WidgetAppointment from './WidgetAppointment.vue';

    @Component({
        name: 'WidgetBasePersonalDashboardPopup',
        components: {
            ActionMenu,
            WidgetCalendar,
            WidgetDefault,
            WidgetStorage,
            WidgetTask,
            WidgetTasktraced,
            WidgetResubmission,
            WidgetBirthday,
            WidgetTicket,
            WidgetOpenFeedback,
            WidgetEvent,
            WidgetAppointment,
            WidgetOpenRequests,
            WidgetFAQ
        },
    })
    export default class WidgetBasePersonalDashboardPopup extends Vue
    {
        @State('layoutData') layoutData: LayoutData;

        @Prop({
            type: Object,
            required: true,
        }) widget: WidgetData;

        @Prop({
            type: Object,
            required: true,
        }) content: WidgetContentProp;

        @Prop({
            type: Boolean,
            default: true,
        }) clickable: boolean;

        isOpen: boolean = true;

        get color(): string
        {
            return this.widget.color
                ? this.widget.color.startsWith('#') || this.widget.color.startsWith('rgb') ? this.widget.color : ('#' + this.widget.color)
                : this.layoutData.colors['rgb-color-headline'];
        }

        get title(): string
        {
            return `${this.widget.name}${this.content.count ? ` (${this.content.count})` : (
                this.content.entries && this.content.entries.length
                    ? ` (${this.content.entries.length})`
                    : ''
            )}`;
        }

        toggleOpen(): void
        {
            this.isOpen = !this.isOpen;
        }
    }
</script>